var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3842 0.447322L20.9571 9.49963C21.1594 9.7104 21.3263 10.0437 21.3487 10.475C21.3256 10.8805 21.2876 11.1661 20.9594 11.4997L12.3888 20.5497C12.1251 20.8292 11.7459 20.9883 11.3614 20.9989C10.9798 21.0095 10.5998 20.8753 10.322 20.5945C10.0578 20.326 9.9106 19.9546 9.90026 19.5802C9.88985 19.203 10.0175 18.8291 10.2779 18.5531L16.5187 11.9536L1.80174 11.9536C1.40032 11.9536 1.03727 11.791 0.774527 11.5282C0.511855 11.2654 0.349365 10.9024 0.349365 10.5009C0.349365 10.0994 0.511853 9.73634 0.774529 9.47357C1.03727 9.21074 1.40032 9.04819 1.80173 9.04819L16.5187 9.04818L10.2774 2.44824C10.0166 2.17172 9.88508 1.79055 9.8956 1.40958C9.90613 1.02836 10.0586 0.655443 10.3351 0.394384C10.6182 0.127168 10.9918 -0.0103822 11.3699 6.62755e-05C11.7284 0.00997303 12.0926 0.151702 12.3842 0.447322Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.ceaf8f68b8e0fc4906b2802ad5046cc5.svg";
export { ForwardRef as ReactComponent };